import script from "./PersonConceptsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonConceptsTab.vue?vue&type=script&setup=true&lang=js"

import "./PersonConceptsTab.vue?vue&type=style&index=0&id=b5ab4896&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ab4896"]])

export default __exports__